import React from 'react';
import { CHAINS } from '../../config/constants';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const ChainSelector = ({ selectedChain, onChainSelect, label, excludeChain, disabled = false, isSource = false, isWrongNetwork = false }) => {
  const availableChains = Object.values(CHAINS).filter(
    chain => chain.id !== excludeChain
  );

  const selectedChainInfo = Object.values(CHAINS).find(
    chain => chain.id === selectedChain
  );

  const handleChainSelect = (chainId) => {
    if (chainId !== selectedChain) {
      onChainSelect(chainId);
    }
  };

  return (
    <div className="flex-1">
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
        {label} {isSource && isWrongNetwork && (
          <span className="text-blue-600 dark:text-blue-400 text-xs ml-1">
            (Switching...)
          </span>
        )}
      </label>
      
      <div className="relative">
        <select
          value={selectedChain}
          onChange={(e) => handleChainSelect(parseInt(e.target.value))}
          disabled={disabled}
          className="input-field appearance-none pr-10 cursor-pointer disabled:cursor-not-allowed"
        >
          {availableChains.map((chain) => (
            <option key={chain.id} value={chain.id}>
              {chain.name}
            </option>
          ))}
        </select>
        
        <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
      </div>

      {/* Chain Info Display */}
      {selectedChainInfo && (
        <div className="mt-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg">
          <div className="flex items-center gap-3">
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center text-white font-semibold text-sm"
              style={{ backgroundColor: selectedChainInfo.color }}
            >
              {selectedChainInfo.symbol.slice(0, 2)}
            </div>
            <div>
              <div className="font-medium text-sm">{selectedChainInfo.name}</div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                Chain ID: {selectedChainInfo.id}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChainSelector; 